import { Button, ButtonProps, Typography } from '@mui/material';
import { MouseEventHandler, useState } from 'react';

type ActionButtonProps = Omit<ButtonProps, 'loading' | 'onClick'> & {
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void | Promise<void>;
};

export const ActionButton = (props: ActionButtonProps) => {
  const [loading, setLoading] = useState(false);

  const onClick: MouseEventHandler<HTMLButtonElement> = async (e) => {
    try {
      setLoading(true);
      await props.onClick?.(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      {...props}
      sx={{ textTransform: 'none' }}
      disabled={loading || props.disabled}
      onClick={onClick}
    >
      <Typography textTransform="none">{props.children}</Typography>
    </Button>
  );
};
